import React from 'react'

export default function TermsOfService() {
  return (
    <div>TermsAndConditions</div>
  )
}
